import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";


const generateMixAudio = async (id) => {
    // {{url}}/api/projects/mix/64ad94894f32f10094c96e77 POST 
    const response = await fetch(`${process.env.REACT_APP_URL}/api/projects/mix/${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
    });
   
    try {
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error(error);
    }finally{
        console.info('end generateMixAudio');
    }
    
};

export const generateUploadMixAudio = async (id, file) => {
    try {
        if (!file) {
            console.error("❌ No se seleccionó ningún archivo.");
            return { error: "No se seleccionó ningún archivo" };
        }

        console.log("📤 Preparando subida a S3...");

        // Usar el nuevo endpoint específico para mix audio
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(`${process.env.REACT_APP_URL}/api/uploads/mix-audio/${id}`, {
            method: 'POST',
            body: formData
        });

        const result = await response.json();

        if (result.status) {
            console.log("✅ Archivo subido a S3:", result.data.nombreUnico);
            
            // Notificar al backend para ejecutar el script en EC2
            const ec2Response = await fetch(`${process.env.REACT_APP_URL}/api/projects/upload-audio-to-s3/${id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ url: result.data.url }),
            });

            if (!ec2Response.ok) {
                throw new Error(`Error al actualizar el proyecto: ${ec2Response.statusText}`);
            }

            console.log("✅ Proyecto actualizado en backend");
            return { success: true, url: result.data.url };
        } else {
            throw new Error(`Error al subir archivo: ${result.msg}`);
        }
    } catch (error) {
        console.error("🔥 Error en generateUploadMixAudio:", error);
        return { error: error.message };
    }
};
export const uploadAudioForSegments = async (file, segmentIds) => {
    try {
        if (!file) {
            console.error("❌ No file selected");
            return { error: "No file selected" };
        }

        if (!segmentIds || segmentIds.length === 0) {
            console.error("❌ No segments selected");
            return { error: "No segments selected" };
        }

        // Check if environment variable is set
        if (!process.env.REACT_APP_URL) {
            console.error("❌ REACT_APP_URL environment variable is not set");
            return { error: "Server configuration error" };
        }

        console.log("📤 Preparing S3 upload...");

        console.log("📁 File:", file.name, "Size:", file.size, "Type:", file.type);
        console.log("🎯 Segment IDs:", segmentIds);

        // Validate file type
        if (file.type !== "audio/wav") {
            console.error("❌ Invalid file type:", file.type);
            return { error: "Only WAV files are allowed" };
        }

        // Create FormData with file and segmentIds
        const formData = new FormData();
        formData.append('file', file);
        formData.append('segmentIds', JSON.stringify(segmentIds));

        // Debug FormData contents
        console.log("📋 FormData contents:");
        for (let [key, value] of formData.entries()) {
            if (key === 'file') {
                console.log(`  ${key}:`, value.name, value.type, value.size);
            } else {
                console.log(`  ${key}:`, value);
            }
        }

        // Use the endpoint without project ID
        const apiUrl = `${process.env.REACT_APP_URL}/api/uploads/segment-audio`;
        console.log("🚀 Making request to:", apiUrl);

        const response = await fetch(apiUrl, {
            method: 'POST',
            body: formData
        });

        console.log("📡 Response status:", response.status);
        console.log("📡 Response headers:", Object.fromEntries(response.headers.entries()));

        if (!response.ok) {
            const errorText = await response.text();
            console.error("❌ Server error response:", errorText);
            
            let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
            try {
                const errorJson = JSON.parse(errorText);
                errorMessage = errorJson.msg || errorJson.message || errorJson.error || errorMessage;
            } catch (e) {
                // If parsing fails, use the raw text
                errorMessage = errorText || errorMessage;
            }
            
            throw new Error(errorMessage);
        }

        const result = await response.json();
        console.log("📄 Server response:", result);

        if (result.status) {
            console.log("✅ File uploaded to S3:", result.data.nombreUnico);
            console.log("🔗 File URL:", result.data.url);
            console.log("✅ Segments updated successfully");
            
            return { 
                success: true, 
                url: result.data.url,
                updatedSegments: result.data.updatedSegments 
            };
        } else {
            throw new Error(`Error uploading file: ${result.msg || result.message || 'Unknown error'}`);
        }
    } catch (error) {
        console.error("🔥 Error in uploadAudioForSegments:", error);
        return { error: error.message };
    }
};
export { generateMixAudio };
